import { TrackingInfo } from "../definitions/general";
import { getCookie, setCookie } from "./cookie";

const updateTrackingInfo = (searchString: string) => {
  const queryParams = new URLSearchParams(searchString);

  const querySource = queryParams.get("utm_source");
  const queryMedium = queryParams.get("utm_medium");
  const queryCampaign = queryParams.get("utm_campaign");
  const queryReferrer = queryParams.get("utm_referrer");
  const cookieSource = getCookie("utm_source");
  const cookieMedium = getCookie("utm_medium");
  const cookieCampaign = getCookie("utm_campaign");
  const cookieReferrer = getCookie("utm_referrer");
  if (querySource != null && querySource !== "") {
    if (!cookieSource || cookieSource !== querySource) {
      setCookie(
        "utm_source",
        querySource,
        +new Date() + 14 * 24 * 60 * 60 * 1000
      );
    }
  }
  if (queryMedium != null && queryMedium !== "") {
    if (!cookieMedium || cookieMedium !== queryMedium) {
      setCookie(
        "utm_medium",
        queryMedium,
        +new Date() + 14 * 24 * 60 * 60 * 1000
      );
    }
  }
  if (queryCampaign != null && queryCampaign !== "") {
    if (!cookieCampaign || cookieCampaign !== queryCampaign) {
      setCookie(
        "utm_campaign",
        queryCampaign,
        +new Date() + 14 * 24 * 60 * 60 * 1000
      );
    }
  }
  if (queryReferrer != null && queryReferrer !== "") {
    if (!cookieReferrer || cookieReferrer !== queryReferrer) {
      setCookie(
        "utm_referrer",
        queryReferrer,
        +new Date() + 14 * 24 * 60 * 60 * 1000
      );
    }
  }
};

const getTrackingInfo: () => TrackingInfo = () => {
  const cookieSource = getCookie("utm_source");
  const cookieMedium = getCookie("utm_medium");
  const cookieCampaign = getCookie("utm_campaign");
  const cookieReferrer = getCookie("utm_referrer");

  return {
    utm_source: cookieSource || "",
    utm_medium: cookieMedium || "",
    utm_campaign: cookieCampaign || "",
    utm_referrer: cookieReferrer || "",
  };
};

const gtag = (window as any).gtag || ((...args: any[]) => {});

export { getTrackingInfo, gtag, updateTrackingInfo };
